import { NgxMatDatetimePickerModule } from '@angular-material-components/datetime-picker';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { ErrorHandler, NgModule } from '@angular/core';
import { AngularFireModule } from '@angular/fire';
import { AngularFireAuthModule } from '@angular/fire/auth';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ServiceWorkerModule } from '@angular/service-worker';
import { HotTableModule } from '@handsontable/angular';
import { LoggerModule, NGXLogger } from 'ngx-logger';
import { environment } from '../environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { Dashboard2025Module } from './dashboard-2025/lohi-dashboard.module';
import { DriversModule } from './drivers/drivers.module';
import { HeatMapCalendarComponent } from './heat-map-calendar/heat-map-calendar.component';
import { LogRocketErrorHandler } from './logrocket-error-handler';
import { MaterialModule } from './material/material.module';
import { NewsAndUpdatesComponent } from './news-and-updates/news-and-updates.component';
import { OwnerDashboardModule } from './owner-dashboard/owner-dashboard.module';
import { ApiIndicatorComponent } from './root/api-indicator/api-indicator.component';
import { AuthInterceptorService } from './root/auth-interceptor.service';
import { CompanySuspensionBannerComponent } from './root/company-suspension-banner/company-suspension-banner.component';
import { AssetManagementComponent } from './root/dashboard/asset-management/asset-management.component';
import { BillingComponent } from './root/dashboard/billing/billing.component';
import { BookedAdvanceComponent } from './root/dashboard/carrier-scorecard/booked-advance/booked-advance.component';
import { CarrierScorecardComponent } from './root/dashboard/carrier-scorecard/carrier-scorecard.component';
import { LoadsDeclinedComponent } from './root/dashboard/carrier-scorecard/loads-declined/loads-declined.component';
import { MissedShiftsComponent } from './root/dashboard/carrier-scorecard/missed-shifts/missed-shifts.component';
import { CoachingComponent } from './root/dashboard/coaching/coaching.component';
import { DriverListComponent } from './root/dashboard/driver-list/driver-list.component';
import { DriverPerformanceComponent } from './root/dashboard/kpi/driver-performance/driver-performance.component';
import { DriverSparkLineComponent } from './root/dashboard/kpi/driver-spark-line/driver-spark-line.component';
import { DriverTierChartComponent } from './root/dashboard/kpi/driver-tier-chart/driver-tier-chart.component';
import { DriverTierMetricChartComponent } from './root/dashboard/kpi/driver-tier-metric-chart/driver-tier-metric-chart.component';
import { DriverTierMetricDetailComponent } from './root/dashboard/kpi/driver-tier-metric-detail/driver-tier-metric-detail.component';
import { KpiComponent } from './root/dashboard/kpi/kpi.component';
import { NavBarPerformanceComponent } from './root/dashboard/kpi/nav-bar-performance/nav-bar-performance.component';
import { RevenuePerformanceComponent } from './root/dashboard/kpi/revenue-performance/revenue-performance.component';
import { LeaderboardsComponent } from './root/dashboard/leaderboards/leaderboards.component';
import { LoadsPerDayChartComponent } from './root/dashboard/loads-per-day-chart/loads-per-day-chart.component';
import { LostEarningsByDriverChartComponent } from './root/dashboard/lost-earnings-by-driver-chart/lost-earnings-by-driver-chart.component';
import { OperationsComponent } from './root/dashboard/operations/operations.component';
import { RevenueChartComponent } from './root/dashboard/revenue-chart/revenue-chart.component';
import { ShiftAveragesComponent } from './root/dashboard/shift-averages/shift-averages.component';
import { ShiftsPerDayChartComponent } from './root/dashboard/shifts-per-day-chart/shifts-per-day-chart.component';
import { MenuComponent } from './root/menu/menu.component';
import { ShiftBookingComponent } from './root/shift-booking/shift-booking.component';
import { VersioningComponent } from './root/versioning/versioning.component';
import { SharedModule } from './shared/shared.module';

const firebaseConfig = {
  apiKey: '',
  authDomain: 'lohi-f5606.firebaseapp.com',
  databaseURL: 'https://lohi-f5606.firebaseio.com',
  projectId: 'lohi-f5606',
  storageBucket: 'lohi-f5606.appspot.com',
  messagingSenderId: '471883051371',
  appId: '1:471883051371:web:dce9808351fc14c0f69c2e',
  measurementId: 'G-E35GJMJZN0',
};

@NgModule({
  declarations: [
    AppComponent,
    AssetManagementComponent,
    VersioningComponent,
    CompanySuspensionBannerComponent,
    MenuComponent,
    ApiIndicatorComponent,
    HeatMapCalendarComponent,
    NewsAndUpdatesComponent,
    OperationsComponent,
    KpiComponent,
    DriverSparkLineComponent,
    BillingComponent,
    CoachingComponent,
    RevenueChartComponent,
    ShiftAveragesComponent,
    LostEarningsByDriverChartComponent,
    ShiftsPerDayChartComponent,
    LoadsPerDayChartComponent,
    LeaderboardsComponent,
    AssetManagementComponent,
    CarrierScorecardComponent,
    MissedShiftsComponent,
    LoadsDeclinedComponent,
    BookedAdvanceComponent,
    DriverListComponent,
    ShiftBookingComponent,
    DriverPerformanceComponent,
    RevenuePerformanceComponent,
    NavBarPerformanceComponent,
    DriverTierChartComponent,
    DriverTierMetricChartComponent,
    DriverTierMetricDetailComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    BrowserAnimationsModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    ServiceWorkerModule.register('ngsw-worker.js', { enabled: !window.location.href.includes('localhost') }),
    AngularFireModule.initializeApp({
      ...firebaseConfig,
      apiKey: environment.firebaseApiKey,
    }),
    AngularFireAuthModule,
    SharedModule,
    LoggerModule.forRoot({
      level: environment.logLevel,
      colorScheme: ['blue', 'teal', 'gray', 'gray', 'red', 'red', 'red'],
      enableSourceMaps: !environment.production,
    }),
    DriversModule,
    Dashboard2025Module,
    OwnerDashboardModule,
    NgxMatDatetimePickerModule,
    HotTableModule.forRoot(),
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptorService,
      multi: true,
    },
    { provide: ErrorHandler, useClass: LogRocketErrorHandler, deps: [NGXLogger] },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
